import { useTranslation } from "react-i18next";
import Auth from "../../utils/Auth";
import { MenuModel } from "../../types";
import { SupplierNav } from "../ApplloLayout/navigations/SupplierNav";
import { AdminNav } from "../ApplloLayout/navigations/AdminNav";
import { DriverNav } from "../ApplloLayout/navigations/DriverNav";
import { sanitizeMenuSections } from "../../utils/menuNavigation";

export function useAppMenuModel(): MenuModel[] {
    const auth = new Auth();
    const { t } = useTranslation();

    if (auth.isSupplierLevelUser()) {
        return sanitizeMenuSections(SupplierNav({ auth, t }));
    }

    if (auth.isDriverLevelUser()) {
        return sanitizeMenuSections(DriverNav({ auth, t }));
    }

    if (auth.isAdminLevelUser()) {
        return sanitizeMenuSections(AdminNav({ auth, t }));
    }

    return sanitizeMenuSections([
        {
            label: "Dashboards",
            icon: "pi pi-home",
            items: [
                {
                    label: "E-Commerce",
                    icon: "pi pi-fw pi-home",
                    to: "/",
                },
            ],
        },
    ]);
}
